import { MainLayout } from '@/components/layout/MainLayout';
import { CalculatorPage } from '@/portal/pages/employee/CalculatorPage';

// The carpenter's calculator, reused as-is from the employee portal —
// same math, same cut lists (device-local either way).
export const AdminCalculatorPage = () => (
  <MainLayout>
    <div className="max-w-xl mx-auto">
      <CalculatorPage />
    </div>
  </MainLayout>
);
